export default __webpack_public_path__ + "static/media/tufts.31c2cc8a.jpeg";